/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/7.webp";
import team3 from "assets/images/8.jpg";
import team4 from "assets/images/9.png";
import team5 from "assets/images/10.webp";
import team6 from "assets/images/11.png";
import team7 from "assets/images/16.jpg";
import team8 from "assets/images/15.webp";
import team9 from "assets/images/12.png";
import team10 from "assets/images/17.webp";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Us?
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Service-Level Agreements (SLAs)"
                position={{ color: "info", label: "Leverage the Expertise of Our Skilled Developers and Engineers" }}
                description="HP Tech Solutions may provide SLAs for specific services to outline the agreed-upon performance standards and uptime guarantees. Any breach of SLA terms will be addressed as outlined in the service agreement."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Third-Party Tools and Services"
                position={{ color: "info", label: "Delivering Intuitive, Beautiful, and Seamless User Journeys" }}
                description="Some of our services may involve third-party tools, software, or integrations. While we strive to use reputable providers, we are not responsible for the performance, availability, or security of third-party tools and services utilized as part of our solutions."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Indemnification"
                position={{ color: "info", label: "Future-Proof Your Website with Scalable and Adaptable Architectures." }}
                description="You agree to indemnify, defend, and hold harmless HP Tech Solutions, its employees, and affiliates from any claims, damages, or expenses arising from your misuse of our services or violation of these Terms and Conditions."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
